import Vue from "vue"
import Toasted from "vue-toasted"

Vue.use(Toasted)

// Options can be added to the toasted like css classes to the container
